import fetch from 'isomorphic-fetch';
import cookie from 'react-cookie';
import { encryptId } from '../utils/userCrypto';
import config from '../config';

const checkStatus = (res) => {
  if (res.status >= 200 && res.status < 300) return res;
  const error = new Error(res.statusText);
  error.response = res;
  error.statusCode = res.status;
  throw error;
};

const parseJSON = response => response.json();

export const doFetchWithOptions = (path, options) => {
  const at = cookie.load('access_token');
  if (at) { // todo remove
    path += `&accesstoken=${at}`; // eslint-disable-line no-param-reassign
  }

  return fetch(`${config.servicesURL}/${path}`, {
    ...options,
  })
    .then(checkStatus)
    .then(parseJSON);
};

const doFetch = (path, userDetails, auth = true) => {
  const at = cookie.load('access_token');
  const legacyId = userDetails ? userDetails.usID || userDetails.legacyId : null;
  let headers = {};

  if (at && auth) {
    path += `&accesstoken=${at}`; // eslint-disable-line no-param-reassign
    headers = {
      token: at,
      'Custom-Authorization': legacyId ? encryptId(legacyId) : '',
    };
  }

  const baseUrl = config.bwHost;
  return fetch(`${baseUrl}/proxy/${path}`, {
    method: 'GET',
    headers,
  })
    .then(checkStatus)
    .then(parseJSON);
};

export const createParamString = params => Object.keys(params)
  .filter(key => (params[key] !== undefined && params[key] !== null))
  .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
  .join('&');

export default doFetch;



// WEBPACK FOOTER //
// ./src/common/baseFetch.js